import makeStyles from "@mui/styles/makeStyles";

export const useFormHelperTextStyles = makeStyles(() => ({
  root: {
    display: "inline",
    alignSelf: "baseline",
    minHeight: 10,
    lineHeight: "10px",
    marginBottom: 7,
    marginTop: 4,
    marginLeft: 10,
    padding: "0 4px",
    fontSize: 10,
    background: "transparent",
    borderRadius: 2,
  },
}));
